<div class="ai-budget-card">
  <div *ngIf="snapshot === null" class="ai-budget-card__loading">Loading…</div>

  <ng-container *ngIf="snapshot !== null">
    <div class="ai-budget-card__title-row">
      <h3 class="ai-budget-card__title">AI Usage Budget</h3>
      <span *ngIf="snapshot.blocked" class="ai-budget-card__over-limit">OVER LIMIT</span>
    </div>

    <p class="ai-budget-card__headline">
      {{ snapshot.usedUsd | currency:'USD' }} / {{ snapshot.capUsd | currency:'USD' }}
    </p>

    <app-progress-bar [value]="progress" [dangerThreshold]="0.9"></app-progress-bar>

    <p class="ai-budget-card__remaining">
      Remaining: {{ snapshot.remainingUsd | currency:'USD' }}
    </p>

    <div *ngIf="canEdit" class="ai-budget-card__actions">
      <saffron-button
        text="Edit"
        type="secondary"
        size="small"
        (click)="onEditClick()"
      ></saffron-button>
    </div>
  </ng-container>
</div>
